import type { DeepReadonly } from "@itandi/itandi-bb-ui";
import type { ReactNode } from "react";
import Styles from "./TableHeader.module.scss";

type Props = DeepReadonly<{
	children: ReactNode;
}>;

export function TableHeader({ children }: Props) {
	return (
		<thead>
			<tr className={Styles.TableHeader}>{children}</tr>
		</thead>
	);
}
